import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/*
import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { SolanaAdapter } from '@reown/appkit-adapter-solana/react'
import { bsc, bscTestnet, solana, solanaDevnet } from '@reown/appkit/networks'

import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

const projectId = 'b0f803c72b166042db6cc637dbf272be' 

const metadata = {
  name: 'Kedzæcarta Cosmic Farm',
  description: 'Farm Token Staking on BSC & Solana',
  url: 'https://kedzeecarta.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks: [bsc, bscTestnet]
})

const solanaAdapter = new SolanaAdapter({
  projectId
})
*/

/*
try {
  createAppKit({
    adapters: [wagmiAdapter, solanaAdapter],
    networks: [bsc, bscTestnet, solana, solanaDevnet],
    projectId,
    metadata,
    features: {
      analytics: true
    },
    themeMode: 'dark',
    themeVariables: {
      '--w3m-accent': '#FF00FF', 
      '--w3m-border-radius-master': '1px'
    }
  })
} catch (e) {
  console.warn("AppKit init failed, proceeding with mount:", e);
}
*/

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
